export const getInstantOatmealPackage = Product => {
  let InstantOatmealPackage = {
    UPC: Product.UPC,
    Kcals: Product.Kcals,
    Folate: Product.Folate,
    Fiber: Product.Fiber,
    WholeGrainCert: Product.WholeGrainCert,
    Iron: Product.Iron,
    Sucrose: Product.Sucrose,
    Rounding: Product.Rounding,
    UnderIronLimit: Product.UnderIronLimit,
    UnderSucroseLimit: Product.UnderSucroseLimit,
    ContainsNoSweeteners: Product.ContainsNoSweeteners,
    OatType: Product.OatType,
    Flavor: Product.Flavor,
    Size: Product.Size,
  }
  return InstantOatmealPackage
}
